/// <reference types="vite/client" />

const chunkLoadErrors = new WeakSet<object>();

// Vite wraps every dynamic import in a preload helper that dispatches "vite:preloadError" with the
// original error before rethrowing it. Tagging that error lets us recognise chunk load failures in
// every browser without matching browser-specific error messages. Call once, before the first
// dynamic import.
export function trackChunkLoadErrors() {
    window.addEventListener("vite:preloadError", (event) => {
        chunkLoadErrors.add(event.payload);
    });
}

export function isChunkLoadError(error: unknown): boolean {
    return typeof error === "object" && error !== null && chunkLoadErrors.has(error);
}
